import { useState } from "react"

import { faIcon } from "@utils/faIcon"

import { Avatar, Button } from "@atoms/index"

import { DisplayModule } from "@molecules/index"

import { useEcommerceAuthorizeMutation } from "@pages/Settings/SettingsEcommerce/SettingsEcommerce.store"
import EcommerceConnectDialog from "@pages/Settings/SettingsEcommerce/components/EcommerceConnectDialog/EcommerceConnectDialog"
import EcommerceConnectionItem from "@pages/Settings/SettingsEcommerce/components/EcommerceConnectionItem/EcommerceConnectionItem"

import styles from "./EcommercePlatformCard.module.scss"
import { EcommercePlatformCardProps } from "./EcommercePlatformCard.types"

export default function EcommercePlatformCard(props: EcommercePlatformCardProps) {
    const { platform, connections } = props

    const authorizeMutation = useEcommerceAuthorizeMutation()

    const [isConnectDialogOpen, setIsConnectDialogOpen] = useState(false)

    const handleConnectClick = () => {
        if (platform.auth_type === "oauth") {
            authorizeMutation.mutate(platform.platform)
        } else {
            setIsConnectDialogOpen(true)
        }
    }

    return (
        <>
            <DisplayModule
                className={styles.base}
                label={
                    <div className={styles.platformIdentity}>
                        <Avatar
                            variant="company"
                            size="lg"
                            src={platform.logo_url ?? undefined}
                            fallbackName={platform.label}
                        />
                        <span>{platform.label}</span>
                    </div>
                }
                headerAction1={
                    <Button
                        variant="solid"
                        size="sm"
                        leftIcon={faIcon({ name: "circle-plus", style: "regular" })}
                        onClick={handleConnectClick}
                        isProcessing={authorizeMutation.isPending}
                        isDisabled={authorizeMutation.isPending}
                    >
                        Connect store
                    </Button>
                }
                contentClassName={styles.connections}
            >
                {connections.length > 0 ? (
                    connections.map((connection) => (
                        <EcommerceConnectionItem key={connection.id} platform={platform} connection={connection} />
                    ))
                ) : (
                    <span className={styles.emptyMessage}>No stores connected yet.</span>
                )}
            </DisplayModule>

            {platform.auth_type === "api_key" && (
                <EcommerceConnectDialog
                    platform={platform}
                    isOpen={isConnectDialogOpen}
                    onOpenChange={setIsConnectDialogOpen}
                />
            )}
        </>
    )
}
